import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vueTap from 'v-tap'

Vue.use(vueTap)

Vue.config.productionTip = false

router.beforeEach((to, _, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
